import { render } from "./EndResetPassword.vue?vue&type=template&id=dc632c08&ts=true"
import script from "./EndResetPassword.vue?vue&type=script&lang=ts"
export * from "./EndResetPassword.vue?vue&type=script&lang=ts"

import "@/styles/login-screen.css?vue&type=style&index=0&lang=css"

import exportComponent from "/root/source/core/frontend/affiliate/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QPageContainer from 'quasar/src/components/page/QPageContainer.js';
import QPage from 'quasar/src/components/page/QPage.js';
import QLayout from 'quasar/src/components/layout/QLayout.js';
import QForm from 'quasar/src/components/form/QForm.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPageContainer,QPage,QLayout,QForm,QInput,QBtn});
